var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-document-form" }, [
    _c(
      "div",
      [
        _c(
          "form-accordion",
          { attrs: { title: _vm.$t("businessDocuments.request_desc") } },
          [
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm.document.Reference !== ""
                  ? _c("form-read-group-label-input", {
                      attrs: {
                        inputLabel: _vm.$t("common.rfrnc"),
                        inputValue: _vm.document.Reference,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.document.DocumentDate !== ""
                  ? _c("form-read-group-label-input", {
                      attrs: {
                        inputLabel: _vm.$t("businessDocuments.creation_date"),
                        inputValue: _vm.document.DocumentDate.substring(0, 7),
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.document.Description !== ""
                ? _c("div", { staticClass: "form-group col-sm-6" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("businessDocuments.request_init_message"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      staticClass: "form-control inputAccordionForm",
                      staticStyle: { "margin-top": "4px" },
                      attrs: { disabled: "" },
                      domProps: { value: _vm.document.Description },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.document.DecisionMessage !== ""
                ? _c("div", { staticClass: "form-group col-sm-6" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("businessDocuments.request_desc_read"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      staticClass: "form-control inputAccordionForm",
                      staticStyle: { "margin-top": "4px" },
                      attrs: { disabled: "" },
                      domProps: { value: _vm.document.DecisionMessage },
                    }),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.showDownloadButton(_vm.document.Status)
          ? _c("div", { staticClass: "row justify-content-start" }, [
              _vm.document.IdSeller
                ? _c("div", { staticClass: "col-md-3 justify-content-start" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "button-action firstButtonMarginTop col-md milkyBlockBlack",
                        attrs: { round: "" },
                        on: {
                          click: function ($event) {
                            return _vm.seeSupplierDetails(_vm.document.IdSeller)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "icon fa fa-arrow-right" }),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "businessDocuments.form_document_redirection_button"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "button-action firstButtonMarginTop col-md milkyBlockBlack",
                    attrs: { round: "" },
                    on: { click: _vm.downloadBusinessDocument },
                  },
                  [
                    _c("i", { staticClass: "icon fa fa-download" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "businessDocuments.form_document_download_button"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _c("br"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.document.Serialize != null &&
        Object.keys(_vm.document.Serialize).length != 0 &&
        this.serializeGet.length != 0
          ? _c(
              "form-accordion",
              {
                attrs: {
                  title: _vm.$t("businessDocuments.doc_details"),
                  open: false,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _vm._l(_vm.serializeGet, function (value) {
                      return [
                        value.type === "object"
                          ? _vm._l(value[0], function (subvalue, subindex) {
                              return _c("form-read-group-label-input", {
                                key: subindex,
                                attrs: {
                                  inputLabel: _vm.$t(
                                    "businessDocuments.serialize." +
                                      _vm.document.Type +
                                      "." +
                                      subindex.name
                                  ),
                                  inputValue:
                                    _vm.document.Serialize[value.name][0][
                                      subindex.name
                                    ],
                                },
                              })
                            })
                          : value.type === "date"
                          ? _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "businessDocuments.serialize." +
                                    _vm.document.Type +
                                    "." +
                                    value.name
                                ),
                                inputValue: _vm.document.Serialize[value.name],
                              },
                            })
                          : value.type === "boolean" && value.change === "0"
                          ? _c("div", { staticClass: "form-group col-sm-6" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.serialize." +
                                        _vm.document.Type +
                                        "." +
                                        value.name
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.document.Serialize[value.name] === "0"
                                ? _c("div", [
                                    _c("i", {
                                      staticClass: "icon fa fa-check",
                                      staticStyle: {
                                        color: "green",
                                        "font-size": "30px",
                                      },
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "common.status.valid_control_key"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ])
                                : _c("div", [
                                    _c("i", {
                                      staticClass: "icon fa fa-ban",
                                      staticStyle: {
                                        color: "red",
                                        "font-size": "30px",
                                      },
                                    }),
                                    _vm._v("  \n              "),
                                    _vm.document.Serialize[value.name] === "1"
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "errors.invalid_control_key"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ])
                                      : _vm.document.Serialize[value.name] ===
                                        "2"
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("errors.out_of_date")
                                              ) +
                                              "\n              "
                                          ),
                                        ])
                                      : _vm.document.Serialize[value.name] ===
                                        "3"
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "errors.invalid_control_key_out_of_date"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                            ])
                          : _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "businessDocuments.serialize." +
                                    _vm.document.Type +
                                    "." +
                                    value.name
                                ),
                                inputValue: _vm.document.Serialize[value.name],
                              },
                            }),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.document.History != null
          ? _c(
              "form-accordion",
              { attrs: { title: _vm.$t("businessDocuments.request_history") } },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "form-group col-sm-12" }, [
                    _c(
                      "table",
                      {
                        staticClass: "table table-striped table-bordered",
                        staticStyle: { "table-layout": "fixed" },
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [
                              _vm._v(
                                _vm._s(_vm.$t("businessDocuments.action_date"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("businessDocuments.doc_status_label")
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.document.History, function (value, index) {
                            return _c("tr", [
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.getDateValue(value.date_change))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.getStatusLabel(value.status))
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }